<template>
    <transition appear enter-active-class="animated bounceInRight">
        <f7-view main>
            <f7-page>
                <!-- header -->
                <cm-navbar :title="$ml.get('ShiftUsers')">
                    <f7-nav-right><f7-link @click="save">{{ $ml.get('save') }}</f7-link></f7-nav-right>
                </cm-navbar>
                <!-- END header -->
                <!-- body -->
                <f7-swiper :params="{ observer: true }">
                    <f7-swiper-slide v-for="(shift, index1) in employees" :key="index1">
                        <f7-block-title>{{ shift.shift }}</f7-block-title>
                        <f7-list>
                            <f7-list-item v-for="(item, index2) in shift.employees"
                                :key="index2" checkbox
                                :title="item.name" name="demo-checkbox"
                                :checked="item.is_checked"
                                @change="onChange(index1, index2, $event)"></f7-list-item>
                        </f7-list>
                    </f7-swiper-slide>
                </f7-swiper>
            </f7-page>
        </f7-view>
    </transition>
</template>

<script>
    import CMNavbar from './Navbar'
    import Mutation from '@/services/api/Mutation'
    import Query    from '@/services/api/Query'

    export default {
        name: 'Container',
        props: {},
        components: {
            'cm-navbar': CMNavbar,
        },
        data() {
            return {
                employees: [],
            }
        },
        methods: {
            percent(container) {
                return (container.capacity / container.max_capacity) * 100
            },

            onChange(index1, index2, event) {
                this.employees[index1].employees[index2].is_checked = event.target.checked
            },

            async save() {
                this.$f7.dialog.preloader(this.$ml.get('processing'))
                let result = await Mutation.editShiftUser(this.$helper.toString(this.employees)).execute()

                /* check & show error */
                if (result.data.errors) {
                    this.$f7.dialog.close()
                    let message = this.$helper.errors(result.data.errors)

                    return this.$f7.dialog.alert(message, this.$ml.get('errors.title'))
                }

                this.employees = this.$helper.data(result, 'edit_shift_user')
                this.$f7.dialog.close()

                return this.$f7.dialog.alert(this.$ml.get('success.editShiftUser'), this.$ml.get('information'))
            },
        },

        async created() {
            let data = await Query.withShiftUsers().get()
            this.employees = this.$helper.data(data, 'shift_users')
        },
    }
</script>

<style scoped>
.progressbar {
    height: 18px;
}
</style>